import type { ChatMessage } from "../types/assistant";

/**
 * The transcript, reduced to what a stateless provider can be sent.
 *
 * Claude has no server-side thread — the messages array is the conversation — so a
 * follow-up question only works if the earlier turns go with it. The transcript in
 * state is not safe to send as-is: it holds the turn currently streaming, turns that
 * errored, and the empty assistant placeholder that exists before the first token.
 */

export type PriorTurn = { role: "user" | "assistant"; content: string };

export function historyFor(messages: ChatMessage[]): PriorTurn[] {
  return messages
    .filter((m) => m.status === "completed" && m.content.trim().length > 0)
    .map((m) => ({ role: m.role, content: m.content }));
}
